module.exports = __webpack_public_path__ + "static/img/travelCol.030756f0.svg";